import { render, staticRenderFns } from "./APIAttributePicker.vue?vue&type=template&id=edcf343c&scoped=true"
import script from "./APIAttributePicker.vue?vue&type=script&lang=js"
export * from "./APIAttributePicker.vue?vue&type=script&lang=js"
import style0 from "./APIAttributePicker.vue?vue&type=style&index=0&id=edcf343c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcf343c",
  null
  
)

export default component.exports